module.exports = __webpack_public_path__ + "img/50-receitas.6e545b7c.png";